import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './SVGIcon.less';

function determineMarkup(data, markup) {
    if (markup) {
        return markup;
    }

    return data.svgs ? data.svgs[Object.keys(data.svgs)[0]] : null;
}

function determineSvgSize(haystack, id) {
    let svgId = 'XX';

    // User is using either markup or GraphQL
    if (haystack) {
        const search = haystack.match(/id="(\S+)"/);

        // length of two or more indicates there has been a match an ID has been fetched in (\S+) capture
        if (search) {
            // [1] index position will be the (\S+) capture
            svgId = search[1];
        }
    }

    // User is using a Defined SVG and thus passing in an id
    if (id) {
        svgId = id;
    }

    // String.endsWith not supported by IE :/
    return svgId.substring(svgId.length - 2);
}

function SVGIcon({className, data, id, inline, inlineFlex, markup, strokeWidth}) {
    // If GraphQL is being used, we may end up in a state where the data is still loading.
    if (data.loading) {
        return null;
    }

    // String.endsWith not supported by ID :/
    const svgMarkup = determineMarkup(data, markup);
    const svgSize = determineSvgSize(svgMarkup, id);
    const svgClasses = classNames(
        'SVGIcon',
        {
            [`SVGIcon--${svgSize}px`]: !isNaN(svgSize),
            [`SVGIcon--stroke-width-${strokeWidth}`]: strokeWidth,
            'SVGIcon--inline': inline,
            'SVGIcon--inline-flex': inlineFlex
        },
        className);
    const xlinkHref = `#SVG_${id}`;

    // If SVG markup is being passed in, render it within in a span.
    if (svgMarkup) {
        return (
            <span className={svgClasses} dangerouslySetInnerHTML={{__html: svgMarkup}} /> // eslint-disable-line react/no-danger
        );
    }

    // If SVG Definition enum is passed in, render an SVG via <use>.
    return (
        <svg
            className={svgClasses}
            focusable={false}
        >
            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={xlinkHref} />
        </svg>
    );
}

SVGIcon.propTypes = {
    /**  For direct GraphQL queries, the individual SVG markup */
    data: PropTypes.shape({
        loading: PropTypes.bool,
        svgs: PropTypes.objectOf(PropTypes.string)
    }),
    /** For using an SVG from an SVG Definition block, the xlink:href of the SVG you want. Used in the 'use' tag to grab it's defintion from the SVG Defintions */
    id: PropTypes.string,
    /** Flag to determine if the SVG is being used inline with text, adds .SVG--inline class */
    inline: PropTypes.bool,
    /** Flag to determine if the SVG is being used inline within a block, adds .SVG--inline-flex class */
    inlineFlex: PropTypes.bool,
    /**  For direct Imports, use this prop to pass in inline SVG markup */
    markup: PropTypes.string,
    /** Optional stroke-width attribute to add to svg, will override default 1.5 CSS. Adds .SVG--stroke-width-#.  Currently only classes for 1 and 2 provided. */
    strokeWidth: PropTypes.number
};

SVGIcon.defaultProps = {
    data: {},
    inline: false,
    inlineFlex: false,
    markup: ''
};

export default SVGIcon;
